import { B2bCampaignPayoutsShow } from '@sh4res/bo-common/components/B2bCampaigns/payouts/B2bCampaignPayoutsShow';

import { ResourceDefinition } from '@Utils/types';

export const campaignsPayoutsResource: ResourceDefinition = {
  options: { label: 'menu.payouts' },
  show: B2bCampaignPayoutsShow,
};
